import { render, staticRenderFns } from "./Dealer.vue?vue&type=template&id=05bab6f4&"
import script from "./Dealer.vue?vue&type=script&lang=js&"
export * from "./Dealer.vue?vue&type=script&lang=js&"
import style0 from "./Dealer.vue?vue&type=style&index=0&id=05bab6f4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports